import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drivr-auth-ui__forget-password-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "drivr-auth-ui__welcome" }, " Did you forget your password? ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "drivr-auth-ui__introduction" }, " Please enter your username and we'll send you an access link. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "drivr-auth-ui__form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doRequest && _ctx.doRequest(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ui_input, {
        id: "username",
        ref: "username",
        modelValue: _ctx.username,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          _ctx.username
        ],
        autocomplete: "username",
        class: "drivr-auth-ui__input",
        required: "",
        name: "username",
        type: "text",
        label: "Username",
        disabled: _ctx.loading,
        autofocus: true
      }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"]),
      _createVNode(_component_ui_button, {
        class: "drivr-auth-ui__button",
        variant: "primary",
        block: "",
        size: "default",
        label: "Request Access Link",
        loading: _ctx.loading,
        disabled: _ctx.loading,
        type: "submit"
      }, null, 8, ["loading", "disabled"]),
      _createVNode(_component_ui_button, {
        label: "Back to Login",
        class: "drivr-auth-ui__button",
        variant: "text",
        size: "default",
        type: "button",
        disabled: _ctx.loading,
        block: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
      }, null, 8, ["disabled"])
    ], 32)
  ]))
}